<template>
  <d-container fluid class="main-content-container h-100 px-4">
    <d-row no-gutters class="h-100">
      <d-col lg="3" md="5" class="auth-form mx-auto my-auto">
        <d-card>
          <d-card-body>
            <!-- Logo -->
            <img
              class="auth-form__logo d-table mx-auto mb-3"
              src="@/assets/images/spring-logo.svg"
              alt="Shards Dashboards - Change Password Template"
            />

            <!-- Title -->
            <h5 class="auth-form__title text-center mb-4">Change Password</h5>

            <!-- Form Fields -->
            <d-form @submit="changePassword">
              <div class="form-group">
                <label for="exampleInputPassword1">Password</label>
                <d-input
                  type="password"
                  id="exampleInputPassword1"
                  placeholder="Password"
                  v-model="password"
                />
              </div>
              <div class="form-group mb-4">
                <label for="exampleInputPassword2">Repeat Password</label>
                <d-input
                  type="password"
                  id="exampleInputPassword2"
                  placeholder="Repeat Password"
                  v-model="repeatPassword"
                />
              </div>
              <d-alert theme="danger" :show="error" dismissible>{{error}}</d-alert>
              <button
                :disabled="isAuthLoading"
                type="submit"
                class="btn btn-pill btn-accent d-table mx-auto"
              >{{ isAuthLoading ? 'Changing Password...' : 'Change Password' }}</button>
            </d-form>
          </d-card-body>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>
<script>
import { AUTH_CHANGE_PASSWORD } from "@/store/types";
import { mapGetters } from "vuex";

export default {
  computed: { ...mapGetters(["isAuthLoading"]) },
  data() {
    return {
      token: "",
      password: "",
      repeatPassword: "",
      error: null
    };
  },
  async mounted() {
    const { token } = this.$route.params;
    this.token = token;
  },
  methods: {
    async changePassword(e) {
      e.preventDefault();
      const { password, repeatPassword, token } = this;
      if (password && repeatPassword && password === repeatPassword) {
        try {
          await this.$store.dispatch(AUTH_CHANGE_PASSWORD, { token, password });
          this.$router.push({ name: "analytics" });
        } catch (err) {
          console.log(err);
        }
      } else {
        this.error = "Password must match";
      }
    }
  }
};
</script>


